module.exports = __webpack_public_path__ + "static/media/img-benefit-bonus@3x.da785249.png";